import { Try } from 'monapt'
import { pathOr } from 'ramda'
import { compose, withHandlers, withProps } from 'recompose'

import { withTrackClickedHandler } from 'components/trackers'
import defaults from 'components/trackers/defaults'
import {
  BackButtonTapped,
  SearchButtonTapped,
} from 'pages/spend/direct-deposit/search/segment'
import withWebView from 'pages/spend/direct-deposit/withWebView'

import { switchUrl, withDirectDepositSearch } from '../enhance'
import searchQuery from '../search.gql'
import { Step, WVProps, subtitle } from '../SearchComponents'

const enhance = compose<WVProps, {}>(
  withWebView,
  withTrackClickedHandler(BackButtonTapped),
  withDirectDepositSearch,
  withProps(({ data }) => {
    if (!data.loading) {
      return {
        bankAccountId: pathOr('', ['spendAccounts', 0, 'id'], data),
        topEmployersList: data?.topEmployersData?.topEmployersList,
        showTopEmployers: false,
      }
    } else {
      return {}
    }
  }),
  withHandlers({
    handleSearch:
      ({
        setStep,
        setSearchTerm,
        client,
        setResults,
        bankAccountId,
        setTrackingId,
        setSearching,
        setHeroSubtitle,
        mobileSessionId,
        analytics,
      }) =>
      ({ searchTerm }) => {
        setSearchTerm(searchTerm)
        setStep(Step.Results)
        setSearching(true)

        analytics.track('Button Tapped', {
          ...defaults('Button Tapped'),
          ...SearchButtonTapped(searchTerm),
        })

        client
          .query({
            query: searchQuery,
            name: 'searchEmployers',
            variables: {
              searchTerm,
              sessionId: mobileSessionId,
              bankAccountId,
            },
          })
          .then(({ data }) => {
            setSearching(false)
            if (data) {
              setTrackingId(data.searchEmployers.trackingId)
              setResults(data.searchEmployers.results)
              setHeroSubtitle(
                subtitle(
                  Step.Results,
                  data.searchEmployers &&
                    data.searchEmployers.results.length > 0,
                ),
              )
            }
          })
      },
    handleAddEmployer:
      ({ history, searchTerm }) =>
      () => {
        history.push('/wv/spend/direct-deposit/pdf', {
          employerName: searchTerm,
        })
      },
    handleResultClick:
      ({ history }) =>
      (e) => {
        history.push(
          switchUrl(e.currentTarget.dataset.switchType, true, true),
          {
            employerName: e.currentTarget.dataset.employerName,
            employerId: e.currentTarget.dataset.employerId,
            ctaUrl: e.currentTarget.dataset.ctaUrl,
            clickSwitchTargetId: e.currentTarget.dataset.clickSwitchTargetId,
            switchType: e.currentTarget.dataset.switchType,
            requireAddress: e.currentTarget.dataset.requireAddress === 'true',
          },
        )
      },
    handleWebViewBack:
      ({ trackClick }) =>
      () => {
        Try(() => trackClick())
        window.location.assign(
          'acorns://event?flow_complete=true&error=false&email=false',
        )
      },
  }),
)

export default enhance
